import { createContext, useContext } from "react";

import { type LayerConfig } from "../../config";

export const ConfigContext = createContext<LayerConfig | null>(null);

export const useConfig = () => {
  const config = useContext(ConfigContext);

  if (!config) {
    throw new Error("ConfigContext not found");
  }

  return config;
};
